import * as React from 'react';
import { IconButton, ModalFullscreen, Spinner } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './NewbuildingChatModal.css';

interface INewbuildingChatModalProps {
  open: boolean;
  url?: string;
  onClose(): void;
}

/** Полноэкранная модалка чата для мобильной версии */
export const NewbuildingChatModal: React.FC<INewbuildingChatModalProps> = ({ open, url, onClose }) => {
  const [isLoading, setIsLoading] = React.useState(true);

  const onLoad = React.useCallback(() => setIsLoading(false), []);

  React.useEffect(() => {
    if (open) {
      setIsLoading(true);
    }
  }, [open, url]);

  return (
    <ModalFullscreen onClose={onClose} open={open} theme="white">
      <div className={styles['container']} data-testid="NewbuildingChatModal">
        <span className={styles['close']}>
          <IconButton data-testid="NewbuildingChatCloseButton" icon={<IconActionClose16 />} onClick={onClose} />
        </span>
        {isLoading && (
          <span className={styles['spinner']} data-testid="spinner">
            <Spinner size={16} />
          </span>
        )}
        {url && <iframe className={styles['iframe']} src={url} onError={onLoad} onLoad={onLoad} />}
      </div>
    </ModalFullscreen>
  );
};
